import React from "react"
import propTypes from "prop-types"
import { CardType } from "../../../lib/utils"
import { getBucketPaymentDetails, getLoansTotalRepayment } from "../financierHelper"
import FinancierBucketCard from "./Card"
import ManageFinancierBucket from "./ManageItem"

class FinancierFillDetails extends React.Component {

  _isMounted = false

  state = {
    allUpfrontPayment: 0,
    allTotalRepayment: 0,
    runningRepaymentSummary: false,
  }

  componentDidMount() {
    this._isMounted = true
    this.loadPaymentDetails(this.props.financierBucket)
  }

  componentWillUnmount() {
    this._isMounted = false
  }

  loadPaymentDetails = financierBucket => {

    const { allUpfrontPayment, allFineractIds } = getBucketPaymentDetails(financierBucket)
    this.setState({
      allUpfrontPayment,
      allTotalRepayment: 0,
      runningRepaymentSummary: false,
    })

    if (allFineractIds.length) {

      this.setState({ runningRepaymentSummary: true })

      getLoansTotalRepayment(allFineractIds)
      .then(allTotalRepayment => {

        if (this._isMounted) {
          this.setState({ allTotalRepayment })
        }
      })
      .catch(error => console.error(error))
      .finally(() => {

        if (this._isMounted) {
          this.setState({ runningRepaymentSummary: false })
        }
      })
    }
  }

  render() {

    const { allUpfrontPayment, allTotalRepayment, runningRepaymentSummary } = this.state

    return (
      <FinancierBucketCard
        { ...this.props }
        allUpfrontPayment={ allUpfrontPayment }
        allTotalRepayment={ allTotalRepayment }
        runningRepaymentSummary={ runningRepaymentSummary }
      />
    )
  }
}

FinancierFillDetails.propTypes = {
  financierBucket: propTypes.object.isRequired,
}

export default function FinancierBucketDetails({ params }) {

  return <ManageFinancierBucket
    params={ params }
    callback={ (data, setFinancierBucket, removeFinancierBucket) =>
      <FinancierFillDetails
        financierBucket={ data }
        setFinancierBucket={ setFinancierBucket }
        removeFinancierBucket={ removeFinancierBucket }
        cardType={ CardType.LARGE }
      />
    }
  />
}



// WEBPACK FOOTER //
// ./src/components/Financiers/Buckets/Details.js